import { lowerFirst } from 'lodash'

import { Expression } from '@skinsoft/types';
import { CACHE_KEYS, ExpressionOfflineDataFetcher } from '@skinsoft/offline';
import { API_ENDPOINTS } from '@skinsoft/network';
import { EntityDataStore } from '@skinsoft/entity-data-store';

declare const config
const EXPRESSION_SEARCH_TYPES: string[] = config.expression_search_types

export class ExpressionDataStore extends EntityDataStore<Expression> {
    public static getInstance() {
        if (!ExpressionDataStore.instance) {
            ExpressionDataStore.instance = new ExpressionDataStore();
        }

        return ExpressionDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$expressionDataStore = ExpressionDataStore.getInstance();
    }

    private static instance: ExpressionDataStore = null as any;

    constructor() {
        super('expressions', EXPRESSION_SEARCH_TYPES)
    }

    public update(id: string, body: Partial<Expression>, endpointOverride?: string, ignoreCachedStatus: boolean = false) {
        let entityType = body.type ?? body.entityType
        if(entityType) {
            entityType = lowerFirst(entityType)
        }
        const endpoint = endpointOverride ?? API_ENDPOINTS[entityType as string]

        return super.update(id, body, endpoint, ignoreCachedStatus)
    }

    protected initializeDataFetcher() {
        this.offlineDataFetcher = new ExpressionOfflineDataFetcher(CACHE_KEYS.Expression)
    }
}
